<template>
  <section
    class="main-slider-section"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <div
      class="container main-slider-container relative"
      :class="{ 'in-viewport': animate }"
    >
      <div class="main-slider grab relative">
        <div
          class="main-slider__slide-content"
          v-for="(slide, index) in _.get(contentData, 'data.list')"
          :key="index"
          :class="[
            { active: activeIndex === index },
            { changeSlide: startAnimation }
          ]"
        >
          <div class="main-slider__slide">
            <div class="main-slider__gray-layer"></div>

            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(slide, 'images[0].devices.mobile')"
                class="img-absolute"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(slide, 'images[0].devices.tablet')"
                class="main-slider__img"
              />
              <img
                :src="_.get(slide, 'images[0].devices.desktop')"
                loading="lazy"
                class="main-slider__img"
                alt="main-slider"
              />
            </picture>
            <div class="main-slider__content">
              <h2 class="title font-48 tbc-light">{{ slide.title }}</h2>
              <div class="text-title font-18 tbc-regular">
                {{ _.get(slide, "teaser") }}
              </div>
              <div
                class="view-more animated-link animated-link-a flex-box al-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                >
                  <path
                    id="Combined_Shape_Copy_2"
                    data-name="Combined Shape Copy 2"
                    d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
                    transform="translate(0 0)"
                    fill="#00aeef"
                  />
                </svg>

                <a
                  class="flex-box tbc-bold uppercase link-opaicty"
                  target="_blank"
                  :href="
                    `/${$store.state.main.locale}/${_.get(
                      slide,
                      'moreLink.url'
                    )}`
                  "
                >
                  {{ _.get(slide, "moreLink.title") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination">
        <div
          class="swiper-pagination-item"
          :class="{ active: activeIndex === index && animate }"
          @click="goToSlide(index)"
          v-for="(slide, index) in _.get(contentData, 'data.list')"
          :key="index"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
// import Swiper from "swiper";

export default {
  props: ["contentData", "evenOdd"],
  data() {
    const that = this;
    return {
      activeIndex: 0,
      changeSlide: false,
      startAnimation: false,
      animate: false,
      animationInterval: 0,
      changes: null,
      swiperOptions: {
        speed: 0,
        autoplay: {
          delay: 4000
        },
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination-gallery",
          clickable: true
        },
        effect: "fade",
        navigation: {
          nextEl: ".main-slider-next",
          prevEl: ".main-slider-prev"
        },
        on: {
          slideChange(swiper) {
            // console.log(swiper.activeIndex, "swiper");
            that.activeIndex = swiper.activeIndex;
            that.changeSlide = true;
          }
        }
      }
    };
  },
  watch: {
    changeSlide(val) {
      if (val) {
        clearInterval(this.animationInterval);
      } else {
        this.sliderAnimation();
      }
    }
  },
  mounted() {
    this.sliderAnimation();
    setTimeout(() => {
      this.animate = true;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.animationInterval);
  },
  methods: {
    goToSlide(index, isArrow = false) {
      if (index >= _.size(_.get(this.contentData, "data.list")) || index < 0) {
        return;
      }
      this.changeSlide = true;
      this.startAnimation = true;
      this.activeIndex = index;
    },
    sliderAnimation() {
      this.animationInterval = setInterval(() => {
        this.startAnimation = true;

        if (
          this.activeIndex ===
          _.size(_.get(this.contentData, "data.list")) - 1
        ) {
          this.activeIndex = -1;
        }
        this.activeIndex += 1;
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeScale {
  0% {
    transform: scale(1.2);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes fadeOpacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes fadeOpacityWIthTransform {
  0% {
    opacity: 0;
    -webkit-opacity: 0;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
  }

  100% {
    opacity: 1;
    -webkit-opacity: 1;
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
  }
}
@media (min-width: 1260px) {
  .container.main-slider-container {
    max-width: 1240px;
  }
}
.main-slider-section {
  padding-bottom: 92px;
  @media (max-width: 1399px) {
    padding-bottom: 55px;
  }
  @media (max-width: 767px) {
    padding-bottom: 34px;
  }
  .main-slider-container {
    opacity: 0;
    -webkit-opacity: 0;
    transform: translateY(20px);
    .animated-link-a a.link-opaicty {
      color: rgba(0, 163, 224, 0.8);
    }
    &.in-viewport {
      opacity: 1;
      -webkit-opacity: 1;
      transform: translateY(0px);
      animation: fadeOpacityWIthTransform 1s ease;
      -webkit-animation: fadeOpacityWIthTransform 1s ease;
    }
    .swiper-pagination {
      display: grid;
      grid-template-columns: repeat(4, minmax(0px, 1fr));
      grid-gap: 30px;
      @media (max-width: 767px) {
        grid-gap: 10px;
      }
      .swiper-pagination-item {
        width: 100%;
        height: 3px;
        background: #364756;
        border-radius: 6px;
        cursor: pointer;
        transition: 0.4s ease;
        position: relative;
        &:after {
          content: "";
          width: 0%;
          height: 3px;
          border-radius: 6px;

          position: absolute;
          left: 0;
          background: var(--tbc-blue);
        }
        &.active {
          background: #00a4e03f;

          &:after {
            content: "";
            width: 100%;
            height: 3px;
            position: absolute;
            background: var(--tbc-blue);
            transition: 5s cubic-bezier(0.18, 0.17, 0.7, 0.88);
          }
          // background: var(--tbc-blue);
        }
      }
    }

    .main-slider {
      cursor: default;
      width: 100%;
      height: 610px;
      overflow: hidden;
      border-radius: 6px;
      margin-bottom: 34px;
      @media (max-width: 1366px) {
        height: 377px;
      }
      @media (max-width: 767px) {
        margin-bottom: 30px;
      }

      &__slide-content {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: opacity 1s ease;
        overflow: hidden;
        opacity: 0;
        &.active {
          opacity: 1;
          .main-slider__content {
            opacity: 1;
            transition-delay: 0.4s;
          }
        }
        &.active.changeSlide {
          opacity: 1;
          animation: 0.6s fadeScale ease;
          .main-slider__content {
            opacity: 1;
            transition-delay: 0.4s;

            // animation: 1.8s fadeOpacity ease;
          }
        }
      }
      &__slide {
        height: 100%;
        width: 100%;
        position: relative;
      }
      &__gray-layer {
        background: rgba(21, 34, 46, 0.5);
        z-index: 9;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 6px;
      }
      &__img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        object-fit: cover;
        // filter: brightness(0.5);
        transition: transform 0.6s ease;
        will-change: transform;
        transform-origin: left;
        border-radius: 6px;
      }
      &__content {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 87px;
        left: 65px;
        max-width: 560px;
        opacity: 0;
        transition: 0.6s ease;
        z-index: 10;
        @media (max-width: 1399px) {
          left: 50px;
        }
        @media (max-width: 1023px) {
          bottom: 66px;
          top: unset;
        }
        @media (max-width: 767px) {
          left: 20px;
        }

        .title {
          color: #f4f6f8;
          margin-bottom: 16px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;

          @media (max-width: 1023px) {
            font-size: 38px;
          }
          @media (max-width: 413px) {
            font-size: 24px;
          }
        }
        .text {
          font-size: 18px;
          line-height: 27px;
          color: #eaeaea;
          @media (max-width: 767px) {
            display: none;
          }
        }
        .text-title {
          color: #dadada;
          opacity: 0.9;
          line-height: 36px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 27px;
          @media (max-width: 767px) {
            display: none;
          }
          @media (max-width: 413px) {
            font-size: 16px;
          }
        }
        .view-more {
          padding-top: 34px;
        }
      }
      .swiper-tabs {
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 65px;
        bottom: 55px;
        // top: 450px;
        cursor: pointer;
        @media (max-width: 1399px) {
          left: 50px;
        }
        @media (max-width: 1023px) {
          display: none;
        }
        &__item {
          padding: 0 25px;
          width: 255px;
          height: 97px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          border: 2px solid #474a52;
          margin-right: 30px;
          transition: 0.4s ease;
          span {
            line-height: 27px;
            color: var(--primary);

            transition: 0.4s ease;
            @media (max-width: 1399px) {
              font-size: 16px;
              line-height: 20px;
            }
          }
          @media (max-width: 1399px) {
            width: 192px;
            margin-right: 20px;
          }
          &.active,
          &:hover {
            background: var(--primary);
            border-color: transparent;
            span {
              color: var(--title-color);
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.main-slider-container {
  .text {
    margin-top: 12px;
    * {
      font-size: 18px;
      line-height: 27px;
      color: #ebebeb;
    }
  }
  .swiper-container {
    border-radius: 6px;
  }
  .swiper-pagination {
    position: relative;
    width: calc(100% - 130px);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    z-index: 10;
    @media (max-width: 1399px) {
      width: 100%;
    }

    .swiper-pagination-gallery {
      width: 100%;
      display: flex;
    }

    .swiper-pagination-bullet {
      width: 138px;
      height: 3px;
      margin-right: 12px;
      background-color: #dadada;
      transition: 0.6s ease;
      opacity: 1;
      border-radius: 6px;
      @media (max-width: 767px) {
        width: 70px;
      }
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
      background: var(--tbc-blue);
      transition: 0.6s ease;
    }
    .swiper-button-disabled {
      cursor: default;
    }
    .main-slider-prev.swiper-button-disabled path,
    .main-slider-next.swiper-button-disabled path {
      fill: #c6c6c6;
    }
    .main-slider-prev,
    .main-slider-next {
      transition: 0.6s;
    }
    .main-slider-prev path,
    .main-slider-next path {
      transition: 0.6s;
    }
    .main-slider-prev:not(.swiper-button-disabled):hover path,
    .main-slider-next:not(.swiper-button-disabled):hover path {
      fill: #00aeef;
    }
  }
}
html[lang="ge"] .main-slider .title {
  text-transform: uppercase !important;
  -moz-font-feature-settings: "case";
  -webkit-font-feature-settings: "case";
  font-feature-settings: "case" on;
}
</style>
